import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthoriseResponseCard } from 'src/app/interfaces/card/responses/AuthoriseResponseCard';
import { InitiateResponseCard } from 'src/app/interfaces/card/responses/InitiateResponseCard';
import { MatchedPlans, MatchResponse } from 'src/app/interfaces/card/responses/InstalmentPlanResponse';
import { PaymentMethodsCard } from 'src/app/interfaces/payment-methods';
import { MaskedData } from 'src/app/interfaces/visa-src/MaskedData';
import { CardService } from 'src/app/services/card/card.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-confirm-selection-version-two',
  templateUrl: './confirm-selection.component.html',
  styleUrls: ['./confirm-selection.component.scss']
})
export class ConfirmSelectionComponent implements OnInit {
  isExpanded: boolean  = false;
  addCardState = true;
  mobile = false;
  loading = false;
  paymentConfirm = false;
  cardExpiryMonthOpt;
  cardExpiryYearOpt;
  headerColor = '';
  color: ThemePalette = 'accent';
  diameterColour = 22;
  diameterContinue = 26;
  transactionCancelled = false;
  navigated;
  matchResponse: MatchResponse;
  plans: MatchedPlans[];
  public maskedDataObj: MaskedData;
  selected: MatchedPlans;
  terms: string;
  vPlanId: string;
  cardForm: FormGroup;
  initiateRequestCard;
  activeCard;
  initiateResponseCard: InitiateResponseCard;

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private _location: Location,
    private cardService: CardService,
    private sessionService: SessionService
  ) {
    breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((data) => {
      this.vPlanId = data.vPlanId;
    })
    this.headerColor = (document.getElementsByClassName('header-container')[0] as HTMLElement).style.backgroundColor;
    this.matchResponse = JSON.parse(sessionStorage.getItem('instalment')).matchResponse
    this.plans = this.matchResponse.matchedPlans;
    for (let matchedPlan of this.matchResponse.matchedPlans) {
      if (matchedPlan.vPlanID === this.vPlanId) {
        this.selected = matchedPlan
      }
    }
    (JSON.parse(sessionStorage.getItem('selectedCard')) as PaymentMethodsCard) !== null
      ?
      (JSON.parse(sessionStorage.getItem('selectedCard')) as PaymentMethodsCard).cardToken !== null
        ?
        this.activeCard = (JSON.parse(sessionStorage.getItem('selectedCard')))
        :
        this.activeCard = false
      :
      this.activeCard = false;
    this.terms = this.selected.termsAndConditions[0].text;
  }

  back() {
    this.navigated = true;
    this.router.navigate(
      [`virtual/card/instalment`]).then(() => {
      this.loading = false;
    });
  }

  initiateRequestCardFn() {
    this.loading = true;
    this.initiateRequestCard = JSON.parse(sessionStorage.getItem('request'));
    if (this.selected.vPlanID != 'straight') {
      this.initiateRequestCard.instalmentCorrelationId = JSON.parse(sessionStorage.getItem('instalment')).correlationId;
      this.initiateRequestCard.visaPlanId = this.selected.vPlanID;
    }
    this.activeCard ? (console.log('? is activeCard')) : (console.log('? is false activeCard'));
    this.cardService.initiateTransaction( this.activeCard ? 'tokenized' : 'plain', this.initiateRequestCard, sessionStorage.getItem('sessionToken')).subscribe((data: InitiateResponseCard) => {
      this.initiateResponseCard = data;
      this.navigated = true;
      if (this.initiateResponseCard.threeDSecureAuthRequired) {
        // Redirect User
        //V30C-68 set session storage acs form
        // console.log('ADDING TO SESSION ACS_FORM');
        sessionStorage.setItem('acs-form', JSON.stringify(this.initiateResponseCard));
      } else {
        this.cardService.authoriseTransaction(sessionStorage.getItem('sessionToken')).subscribe((dataAuthorise: AuthoriseResponseCard) => {
          this.navigateToStatus();
        }, (err) => {
          this.navigateToStatus();
        });
      }
    }, (err: HttpErrorResponse) => {
      this.navigateToStatus();
    });
  }


  navigateToStatus() {
    this.loading = false;
    this.router.navigate(
      [`${this.sessionService.getVirtualTwoBaseurl()}/transaction-status`]);
  }
  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

}
